<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/purchase/requisition' }">采购申请</el-breadcrumb-item>
                <el-breadcrumb-item>{{ isEdit ? '编辑申请单' : isView ? '查看申请单' : '新增申请单' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-tabs v-model="activeTab" type="border-card">
            <!-- 基本信息 Tab -->
            <el-tab-pane label="基本信息" name="basic">
                <el-form :model="forms" :rules="rules" ref="forms" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="申请单号" prop="billCode">
                                <el-input v-model="forms.billCode" :disabled="true || isEdit || isView"
                                    style="max-width: 220px;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="单据类型" prop="billType" style="width:350px">
                                <el-select v-model="forms.billType" placeholder="请选择" :disabled="isView">
                                    <el-option label="常规采购" value="常规采购"></el-option>
                                    <el-option label="紧急采购" value="紧急采购"></el-option>
                                    <el-option label="计划采购" value="计划采购"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="制单日期" prop="billDate">
                                <el-date-picker v-model="forms.billDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="所属公司" prop="companyID">
                                <el-tree-select ref="companys" v-model="forms.companyID" :data="companys"
                                    @change="companyChange();" check-strictly
                                    :render-after-expand="false" style="width: 280px;" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="申请部门" prop="departmentID">
                                <el-tree-select ref="departments" v-model="forms.departmentID" :data="departments"
                                    clearable check-strictly :render-after-expand="false" style="width:220px"
                                    @change="onDepartmentChange" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="申请人" prop="applicantName">
                                <el-input v-model="forms.applicantName" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="申请日期" prop="applicantDate">
                                <el-date-picker v-model="forms.applicantDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="需求日期" prop="requirementDate">
                                <el-date-picker v-model="forms.requirementDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="外部编号" prop="externalNo">
                                <el-input v-model="forms.externalNo" :disabled="isView" style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="建议供应商" prop="suggestSupplierCode">
                                <el-select v-model="forms.suggestSupplierCode" filterable clearable placeholder="请选择供应商"
                                    :disabled="isView" style="width:220px" @change="(value) => {
                                        const selected = suppliers.find(s => s.supplierCode === value);
                                        forms.suggestSupplierName = selected ? selected.supplierName : '';
                                    }">
                                    <el-option v-for="s in suppliers" :key="s.supplierCode"
                                        :label="s.supplierName || s.text" :value="s.supplierCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :xs="24">
                            <el-form-item label="备注" prop="remark">
                                <el-input v-model="forms.remark" type="textarea" :rows="2" :disabled="isView"
                                    style="width:95%"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>

            <el-tab-pane label="附件" name="attachment">
                <div class="attachments-pane">
                    <el-alert
                        type="info"
                        show-icon
                        title="附件通过申请单号关联，请确保已生成申请单号后再上传"
                        class="attachments-alert"
                    />
                    <el-upload
                        class="attachments-uploader"
                        :action="uploadAction"
                        list-type="picture-card"
                        :file-list="fileList"
                        :on-success="handleAttachmentUploadSuccess"
                        :before-upload="handleAttachmentBeforeUpload"
                        :on-preview="handleAttachmentPreview"
                        :disabled="isView"
                        accept="*/*"
                    >
                        <el-icon>
                            <Plus />
                        </el-icon>
                        <template #file="{ file }">
                            <div>
                                <img
                                    v-if="['jpg','jpeg','png','bmp'].includes((file.ext || '').toLowerCase())"
                                    class="el-upload-list__item-thumbnail"
                                    :src="file.url"
                                    alt=""
                                />
                                <div v-else class="attachments-file-text">
                                    <span>{{ file.name }}</span>
                                </div>
                                <span class="el-upload-list__item-actions">
                                    <span
                                        class="el-upload-list__item-preview"
                                        @click="handleAttachmentPreview(file)"
                                        title="预览"
                                    >
                                        <el-icon>
                                            <ZoomIn />
                                        </el-icon>
                                    </span>
                                    <span
                                        class="el-upload-list__item-delete"
                                        @click="handleAttachmentDownload(file)"
                                        title="下载"
                                    >
                                        <el-icon>
                                            <Download />
                                        </el-icon>
                                    </span>
                                    <span
                                        v-if="!isView"
                                        class="el-upload-list__item-delete"
                                        @click="handleAttachmentRemove(file)"
                                        title="删除"
                                    >
                                        <el-icon>
                                            <Delete />
                                        </el-icon>
                                    </span>
                                </span>
                            </div>
                        </template>
                    </el-upload>
                    <el-empty v-if="!fileList.length && !forms.billCode" description="暂无附件，待申请单号生成后可上传" />
                </div>
            </el-tab-pane>

        </el-tabs>

        <div style="text-align:left; margin-top: 20px;">
            <el-button type="primary" icon="Select" @click="submit" v-if="!isView">保存</el-button>
            <el-button icon="Back" @click="back">返回</el-button>
        </div>

        <div style="margin-top: 15px;">
            <el-card>
                <template #header>
                    <div style="display:flex;align-items:center;justify-content:space-between;">
                        <div>采购申请单明细</div>
                        <div>
                            <el-button plain icon="Plus" type="primary" size="small" @click="addDetail" v-if="!isView">
                                新增明细
                            </el-button>

                            <el-dropdown v-if="!isView" style="margin:0px 10px;" size="small">
                                <el-button plain icon="Upload" type="primary" size="small">
                                    数据操作
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item>导入明细</el-dropdown-item>
                                        <el-dropdown-item @click="downloadTemplate">下载模板</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </div>
                    </div>
                </template>

                <el-table ref="detailTable" :data="details" stripe border style="width: 100%">
                    <el-table-column type="selection" width="55" fixed="left"></el-table-column>
                    <el-table-column type="index" label="序号" width="55" fixed="left"></el-table-column>
                    <el-table-column prop="channel" width="130">
                        <template #header><span class="required-column-label">备货渠道</span></template>
                        <template #default="{ row }">
                            <el-select v-model="row.channel" filterable placeholder="渠道" :disabled="isView" size="small" style="width:100%">
                                <el-option v-for="item in channels" :key="item.value" :label="item.label || item.name" :value="item.value || item.name"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productSearchText" width="180">
                        <template #header><span class="required-column-label">SKU选择</span></template>
                        <template #default="{ row }">
                            <el-autocomplete v-model="row.productSearchText"
                                :fetch-suggestions="(queryString, cb) => searchProductAsync(queryString, cb, row)"
                                placeholder="编号/名称/条码" :disabled="Boolean(row.id) || isView"
                                @select="item => handleProductSelect(item, row)" size="small" style="width:100%"
                                :trigger-on-focus="false" :debounce="300">
                                <template #default="{ item }">
                                    <div class="sku-suggestion">
                                        <span>{{ item.detailCode }}</span>
                                        <span>{{ item.serialCode }}</span>
                                        <span>{{ item.detailName }}</span>
                                    </div>
                                </template>
                            </el-autocomplete>
                        </template>
                    </el-table-column>
                    <el-table-column prop="productBarcode" label="品牌款号" width="110" show-overflow-tooltip>
                        <template #default="{ row }"><span>{{ row.productBarcode || '-' }}</span></template>
                    </el-table-column>
                    <el-table-column prop="productName" width="180">
                        <template #header><span class="required-column-label">货品名称</span></template>
                        <template #default="{ row }"><el-input v-model="row.productName" size="small" :disabled="isSkuFieldDisabled(row, 'productName')" /></template>
                    </el-table-column>
                    <el-table-column prop="unitName" width="90">
                        <template #header><span class="required-column-label">单位</span></template>
                        <template #default="{ row }"><el-input v-model="row.unitName" size="small" :disabled="isView" /></template>
                    </el-table-column>
                    <el-table-column prop="requiredQuantity" width="140">
                        <template #header><span class="required-column-label">申请备货数量</span></template>
                        <template #default="{ row }">
                            <el-input-number v-model="row.requiredQuantity" size="small" :disabled="isView"
                                @change="onQuantityOrPriceChange(row)" :precision="4" :min="0" style="width:100%" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="hasReport" width="120">
                        <template #header><span class="required-column-label">是否有报告</span></template>
                        <template #default="{ row }">
                            <el-select v-model="row.hasReport" placeholder="必选" :disabled="isView" size="small" style="width:100%">
                                <el-option label="是" :value="true" /><el-option label="否" :value="false" />
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goldMaterialCode" label="金料材质" width="135">
                        <template #default="{ row }"><el-select v-model="row.goldMaterialCode" clearable size="small" :disabled="isView" placeholder="不含金可留空"><el-option v-for="m in metals" :key="m.name" :label="m.value || m.name" :value="m.name" /></el-select></template>
                    </el-table-column>
                    <el-table-column prop="estimatedGoldWeight" label="预计金重(g)" width="145">
                        <template #default="{ row }"><el-input-number v-model="row.estimatedGoldWeight" :min="0" :precision="4" size="small" :disabled="isView" style="width:100%" /></template>
                    </el-table-column>
                    <el-table-column prop="brandCode" label="备货品牌" width="130">
                        <template #default="{ row }">
                            <el-select v-model="row.brandCode" filterable clearable placeholder="品牌"
                                :disabled="isSkuFieldDisabled(row, 'brandCode')" style="width:100%" size="small"
                                @change="value => onBrandChange(row, value)">
                                <el-option v-for="b in brands" :key="b.id || b.brandCode" :label="b.brandName || b.BrandName" :value="b.brandCode || b.BrandCode"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="detailImg" label="图片" width="80">
                        <template #default="{ row }">
                            <el-image style="height: 32px; width: 32px" lazy
                                :src="apiUrl + 'static/code/' + row.detailCode + '?t=0'"
                                :preview-src-list="[apiUrl + 'static/code/' + row.detailCode + '?t=1']">
                                <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" /></template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="supplierProductCode" label="工厂款号" width="120">
                        <template #default="{ row }"><el-input v-model="row.supplierProductCode" size="small" :disabled="isSkuFieldDisabled(row, 'supplierProductCode')" /></template>
                    </el-table-column>
                    <el-table-column prop="weightRange" label="金重范围" width="120">
                        <template #default="{ row }"><el-input v-model="row.weightRange" size="small" :disabled="isSkuFieldDisabled(row, 'weightRange')" /></template>
                    </el-table-column>
                    <el-table-column prop="productSpec" label="规格尺寸" width="150">
                        <template #default="{ row }"><el-input v-model="row.productSpec" size="small" :disabled="isSkuFieldDisabled(row, 'productSpec')" /></template>
                    </el-table-column>
                    <el-table-column prop="estimatedPrice" label="预计入库成本价" width="170">
                        <template #default="{ row }">
                            <el-input-number v-model="row.estimatedPrice" size="small" :disabled="isView"
                                @change="onQuantityOrPriceChange(row)" :precision="4" :min="0" style="width:100%" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="monthSalesQty" width="150">
                        <template #header>
                            <div class="month-sales-header">
                                <span>近1个月销量</span>
                                <el-tooltip v-if="!isView" content="抓取同公司、同渠道、同SKU最近30天销量及本部门、其他部门可用库存" placement="top">
                                    <el-button link type="primary" icon="Refresh" :loading="salesAndStockRefreshing"
                                        aria-label="刷新近30天销量及部门库存" @click.stop="refreshSalesAndStock" />
                                </el-tooltip>
                            </div>
                        </template>
                        <template #default="{ row }">
                            <el-input-number v-model="row.monthSalesQty" size="small" :disabled="isView" :precision="4" :min="0" style="width:100%" />
                        </template>
                    </el-table-column>
                    <el-table-column v-for="column in snapshotQtyColumns" :key="column.prop" :prop="column.prop" :label="column.label" :width="column.width">
                        <template #default="{ row }">
                            <el-input-number v-model="row[column.prop]" size="small" :disabled="isView" :precision="4" :min="0" style="width:100%" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="estimatedAmount" label="备货金额合计" width="120">
                        <template #default="{ row }"><span>{{ formatAmount(row.estimatedAmount) }}</span></template>
                    </el-table-column>
                    <el-table-column prop="minOrderQty" label="工厂最低起订量" width="140">
                        <template #default="{ row }"><el-input-number v-model="row.minOrderQty" size="small" :disabled="isView" :precision="4" :min="0" style="width:100%" /></template>
                    </el-table-column>
                    <el-table-column prop="acceptMinQty" label="按工厂最低起订量下单" width="190">
                        <template #default="{ row }">
                            <el-select v-model="row.acceptMinQty" clearable :disabled="isView" size="small" style="width:100%">
                                <el-option label="是" :value="true" /><el-option label="否" :value="false" />
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="purchaseReason" label="备货原因" width="180">
                        <template #default="{ row }"><el-input v-model="row.purchaseReason" size="small" :disabled="isView" /></template>
                    </el-table-column>
                    <el-table-column prop="sellOutDate" label="预估/计划售完时间" width="170">
                        <template #default="{ row }"><el-date-picker v-model="row.sellOutDate" type="date" size="small" :disabled="isView" format="YYYY-MM-DD" style="width:100%" /></template>
                    </el-table-column>
                    <el-table-column prop="remark" label="申请备注" width="180">
                        <template #default="{ row }"><el-input v-model="row.remark" size="small" :disabled="isView" /></template>
                    </el-table-column>
                    <el-table-column prop="nonFinishedQty" label="非成品库库存数量" width="150">
                        <template #default="{ row }"><el-input-number v-model="row.nonFinishedQty" size="small" :disabled="isView" :precision="4" :min="0" style="width:100%" /></template>
                    </el-table-column>
                    <el-table-column prop="suggestSupplierCode" label="供应商名称" width="150">
                        <template #default="{ row }">
                            <el-select v-model="row.suggestSupplierCode" filterable clearable placeholder="供应商"
                                :disabled="isSkuFieldDisabled(row, 'suggestSupplierCode')" style="width:100%" size="small"
                                @change="value => onSupplierChange(row, value)">
                                <el-option v-for="s in suppliers" :key="s.supplierCode" :label="s.supplierName || s.text" :value="s.supplierCode" />
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderDate" label="下单时间" width="140">
                        <template #default="{ row }"><el-date-picker v-model="row.orderDate" type="date" size="small" :disabled="isView" @change="recalculateSchedule(row)" format="YYYY-MM-DD" style="width:100%" /></template>
                    </el-table-column>
                    <el-table-column prop="leadDays" label="工期（天）" width="120">
                        <template #default="{ row }"><el-input-number v-model="row.leadDays" size="small" :disabled="isSkuFieldDisabled(row, 'leadDays')" @change="recalculateSchedule(row)" :precision="0" :min="0" style="width:100%" /></template>
                    </el-table-column>
                    <el-table-column prop="estShipDate" label="预计出货时间" width="140">
                        <template #default="{ row }"><el-date-picker v-model="row.estShipDate" type="date" size="small" :disabled="isView" format="YYYY-MM-DD" style="width:100%" /></template>
                    </el-table-column>
                    <el-table-column prop="qcLeadDays" label="质检做证挂签分装工期（天）" width="220">
                        <template #default="{ row }"><el-input-number v-model="row.qcLeadDays" size="small" :disabled="isSkuFieldDisabled(row, 'qcLeadDays')" @change="recalculateSchedule(row, false)" :precision="0" :min="0" style="width:100%" /></template>
                    </el-table-column>
                    <el-table-column prop="estInboundDate" label="预计入库时间" width="140">
                        <template #default="{ row }"><el-date-picker v-model="row.estInboundDate" type="date" size="small" :disabled="isView" format="YYYY-MM-DD" style="width:100%" /></template>
                    </el-table-column>
                    <el-table-column prop="followRemark" label="跟单备注" width="180">
                        <template #default="{ row }"><el-input v-model="row.followRemark" size="small" :disabled="isView" /></template>
                    </el-table-column>
                    <el-table-column prop="allowSupplierGoldDebt" label="允许供应商欠料" width="150">
                        <template #default="{ row }"><el-switch v-model="row.allowSupplierGoldDebt" :disabled="isView" /></template>
                    </el-table-column>
                    <el-table-column prop="provisionalGoldPrice" label="欠料预估金价" width="145">
                        <template #default="{ row }"><el-input-number v-model="row.provisionalGoldPrice" :min="0" :precision="4" size="small" :disabled="isView || !row.allowSupplierGoldDebt" style="width:100%" /></template>
                    </el-table-column>
                    <el-table-column prop="goldSettlementStatus" label="金料状态" width="120">
                        <template #default="{ row }">{{ goldStatusLabel(row.goldSettlementStatus) }}</template>
                    </el-table-column>
                    <el-table-column v-if="isEdit || isView" prop="requiredDate" label="要求到货" width="140">
                        <template #default="{ row }"><el-date-picker v-model="row.requiredDate" type="date" size="small" :disabled="isView" format="YYYY-MM-DD" style="width:100%" /></template>
                    </el-table-column>
                    <el-table-column v-if="isEdit || isView" prop="stampText" label="字印" width="150">
                        <template #default="{ row }"><el-input v-model="row.stampText" size="small" :disabled="isView" /></template>
                    </el-table-column>
                    <el-table-column label="操作" width="90" fixed="right">
                        <template #default="{ $index }">
                            <el-button @click="deleteDetailRow($index)" link size="small" type="danger" v-if="!isView">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>

    </el-card>
</template>

<script>
import { fetchBillCode, fetchPurchaseSupplier, fetchPurchaseBrand, refreshRequisitionSalesAndStock } from '@/api/purchase'
import { searchSkuList } from '@/api/product'
import { fetchFileList, delFile } from '@/api/basic'
import { Plus, ZoomIn, Download, Delete } from '@element-plus/icons-vue'

export default {
    name: 'PurchaseRequisitionBill',
    components: {
        Plus,
        ZoomIn,
        Download,
        Delete
    },
    data() {
        return {
            apiUrl: '',
            activeTab: 'basic',
            companys: [],
            departments: [],
            suppliers: [],
            brands: [],
            channels: [],
            metals: [],
            fileList: [],
            salesAndStockRefreshing: false,

            snapshotQtyColumns: [
                { prop: 'deptStockQty', label: '本部门现有库存数量', width: 160 },
                { prop: 'otherDeptStockQty', label: '其他部门现有库存数量', width: 170 },
                { prop: 'transferQty', label: '可支持调拨数量', width: 150 }
            ],

            details: [],
            forms: {
                billDate: new Date(),
                applicantDate: new Date(),
                status: 0,
                totalQuantity: 0,
                totalAmount: 0,
                companyID: '',
                companyName: '',
                departmentID: '',
                departmentName: '',
                billCode: '',
                billType: '',
                externalNo: '',
                suggestSupplierCode: '',
                suggestSupplierName: ''
            },
            // 表单校验规则
            rules: {
                billCode: [
                    { required: true, message: '申请单号不能为空', trigger: 'blur' }
                ],
                billType: [
                    { required: true, message: '请选择单据类型', trigger: 'change' }
                ],
                billDate: [
                    { required: true, message: '请选择制单日期', trigger: 'change' }
                ],
                applicantDate: [
                    { required: true, message: '请选择申请日期', trigger: 'change' }
                ],
                companyID: [
                    { required: true, message: '请选择所属公司', trigger: 'change' }
                ],
                departmentID: [
                    { required: true, message: '请选择申请部门', trigger: 'change' }
                ],
                applicantName: [
                    { required: true, message: '请输入申请人', trigger: 'blur' },
                    { min: 2, max: 50, message: '申请人长度在 2 到 50 个字符', trigger: 'blur' }
                ],
                requirementDate: [
                    { required: true, message: '请选择需求日期', trigger: 'change' }
                ]
            },
        }
    },
    computed: {
        isEdit() { return this.$route.query.id && this.$route.query.mode !== 'view' },
        isView() { return this.$route.query.mode === 'view' },
        requisitionId() { return this.$route.query.id },
        uploadAction() {
            const code = this.forms.billCode || ''
            return `${this.apiUrl}BaseUploader/Basic?dataType=PurchaseRequisition&dataID=${code}&fileType=form&fileCode=${code}`
        }
    },
    mounted() {
        this.apiUrl = process.env.VUE_APP_BASEURL;
        this.$kaung.init(this.$options.name);

        this.$kaung.companys().then((res) => {
            this.companys = res;
            this.companyChange();
        });

        fetchPurchaseSupplier().then((res) => {
            if (res && res.code === 200) {
                this.suppliers = Array.isArray(res.data) ? res.data : []
            }
        });

        // 加载品牌列表
        fetchPurchaseBrand().then((res) => {
            if (res && res.code === 200) {
                this.brands = Array.isArray(res.data) ? res.data : []
            }
        });

        this.$kaung.dictionary("stock", "channel").then(res => {
            this.channels = Array.isArray(res) ? res : []
        });
        this.$kaung.dictionary("stock", "metal").then(res => {
            this.metals = Array.isArray(res) ? res : []
        });

        if (this.requisitionId) {
            this.load();
        } else {
            fetchBillCode(this.$options.name).then(res => {
                this.forms.billCode = res.data || '';
                this.forms.billType = '常规采购';
                this.forms.applicantName = this.$store.getters.getUserInfo.realName || this.$store.getters.getUserInfo.userName || '';
                //console.log('getUserInfo', this.$store.getters.getUserInfo)
                this.forms.companyID = this.$store.getters.getUserInfo.companyID || '';
                this.forms.departmentID = this.$store.getters.getUserInfo.departmentID || ''
                this.companyChange(this.forms.departmentID);
                this.loadAttachments();
            })
        }
    },
    methods: {
        /** 将采购链路中的金料结算状态转换为业务人员可读文本。 */
        goldStatusLabel(status) {
            const labels = {
                not_involved: '未涉及',
                reserved: '已占用',
                deducted: '已扣减',
                partial_debt: '部分欠料',
                debt: '欠料',
                settled: '已结清',
                released: '已释放'
            }
            return labels[status] || (status || '未涉及')
        },
        // 搜索货品信息
        searchProductAsync(queryString, callback, row) {
            if (!queryString || queryString.trim().length < 2) {
                callback([]);
                return;
            }

            searchSkuList(queryString).then(res => {
                if (res && res.data && res.data.data) {
                    const suggestions = res.data.data;
                    callback(suggestions);
                } else {
                    callback([]);
                }
            }).catch(err => {
                console.error('Product search error:', err);
                callback([]);
            });
        },
        // 选择货品后填充信息
        handleProductSelect(item, row) {
            if (!item) return;

            const productSpec = this.buildProductSpec(item)
            row._skuLockedFields = {
                productCode: Boolean(item.productCode),
                productName: Boolean(item.detailName),
                brandCode: Boolean(item.brandCode || item.brandName),
                supplierProductCode: Boolean(item.factoryModelCode),
                weightRange: Boolean(item.weightRange),
                productSpec: Boolean(productSpec),
                suggestSupplierCode: Boolean(item.factoryCode || item.factoryName),
                leadDays: item.factoryDeliveryCycleDays !== null && item.factoryDeliveryCycleDays !== undefined,
                qcLeadDays: item.inboundCycleDays !== null && item.inboundCycleDays !== undefined
            }

            row.productId = item.productID || '';
            row.productCode = item.productCode || '';
            row.productName = item.detailName || '';
            row.productSpec = productSpec;
            row.weightRange = item.weightRange || '';
            row.productBarcode = item.brandModelCode || '';
            row.detailId = item.id || '';
            row.detailCode = item.detailCode || '';
            row.detailName = item.detailName || '';

            // 设置搜索文本为货品编号，便于显示和编辑
            row.productSearchText = item.detailCode || item.serialCode || item.brandModelCode || item.factoryModelCode || '';

            row.suggestSupplierCode = item.factoryCode || '';
            row.suggestSupplierName = item.factoryName || '';
            row.supplierProductCode = item.factoryModelCode || '';
            row.brandCode = item.brandCode || '';
            row.brandName = item.brandName || '';
            row.estimatedPrice = item.purchasePrice ?? null;
            row.leadDays = item.factoryDeliveryCycleDays ?? null;
            row.qcLeadDays = item.inboundCycleDays ?? null;

            this.onQuantityOrPriceChange(row)
            this.recalculateSchedule(row)

            this.$message.success('货品信息已填充');
        },
        load() {
            this.$kaung.getone(this.requisitionId).then(res => {
                if (res.code === 200) {
                    this.forms = { ...res.data };
                    this.forms.applicantDate = this.forms.applicantDate || this.forms.billDate || new Date()
                    this.companyChange(this.forms.departmentID);
                    this.loadAttachments();
                }
            });

            this.fetchDetails();
        },
        fetchDetails() {
            this.$kaung.fetch({ url: 'PurchaseRequisitionDetail/GetDetailList', params: { billId: this.requisitionId }, method: 'get' })
                .then(res => {
                    if (res && res.code === 200) {
                        this.details = res.data;
                        this.details.forEach(detail => {
                            detail.productSearchText = detail.detailCode;
                            detail._isNew = false;
                            detail._skuLockedFields = {};
                        });
                    }
                })
        },
        // 同步附件列表，确保文件与申请单号绑定
        loadAttachments() {
            const billCode = this.forms.billCode
            if (!billCode) {
                this.fileList = []
                return
            }

            fetchFileList(billCode).then(res => {
                if (res && res.code === 200) {
                    this.fileList = Array.isArray(res.data) ? res.data : []
                }
            })
        },
        handleAttachmentBeforeUpload() {
            if (!this.forms.billCode) {
                this.$message.warning('请先生成申请单号后再上传附件')
                return false
            }
            return true
        },
        handleAttachmentUploadSuccess(res) {
            if (res && res.code === 200) {
                this.$message.success(res.content || '上传成功')
                this.loadAttachments()
            } else {
                this.$message.error(res?.content || '上传失败')
            }
        },
        handleAttachmentPreview(file) {
            if (file && file.id) {
                window.open('/preview?id=' + file.id)
            } else if (file && file.url) {
                window.open(file.url)
            }
        },
        handleAttachmentDownload(file) {
            if (file && file.url) {
                window.open(file.url)
            }
        },
        handleAttachmentRemove(file) {
            if (!file || !file.id) {
                return
            }

            this.$confirm('确定要删除该附件吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delFile(file.id).then(res => {
                    if (res && res.code === 200) {
                        this.$message.success(res.content || '删除成功')
                        this.loadAttachments()
                    } else {
                        this.$message.error(res?.content || '删除失败')
                    }
                })
            }).catch(() => { })
        },
        addDetail() {
            const newDetail = {
                id: null,
                billId: this.requisitionId || '',
                channel: this.getDefaultChannel(),
                productCode: '',
                productBarcode: '',
                productName: '',
                unitName: '',
                weightRange: '',
                requiredQuantity: 0,
                estimatedPrice: null,
                estimatedAmount: 0,
                monthSalesQty: null,
                deptStockQty: null,
                otherDeptStockQty: null,
                transferQty: null,
                minOrderQty: null,
                acceptMinQty: null,
                sellOutDate: null,
                hasReport: null,
                nonFinishedQty: null,
                orderDate: null,
                leadDays: null,
                estShipDate: null,
                qcLeadDays: null,
                estInboundDate: null,
                requiredDate: null,
                remark: '',
                followRemark: '',
                stampText: '',
                goldMaterialCode: '',
                estimatedGoldWeight: null,
                allowSupplierGoldDebt: false,
                provisionalGoldPrice: null,
                goldSettlementStatus: 'not_involved',
                _skuLockedFields: {},
                _isNew: true
            }

            this.details.push(newDetail)
        },
        editDetail(row) {
            const detailId = row && row.id ? row.id : 'add'
            this.$router.push({ name: 'PurchaseRequisitionDetail', query: { id: this.requisitionId, detail: detailId } })
        },

        submit() {
            // 首先验证表单
            this.$refs.forms.validate((valid) => {
                if (!valid) {
                    this.$message.error('请完善必填信息');
                    return false;
                }

                // 验证明细数据
                if (!this.details || this.details.length === 0) {
                    this.$message.error('请至少添加一条采购明细');
                    return false;
                }

                // 验证明细必填字段
                for (let i = 0; i < this.details.length; i++) {
                    const detail = this.details[i];
                    if (!detail.detailId || !detail.productName) {
                        this.$message.error(`第 ${i + 1} 行：请选择SKU，货品名称不能为空`);
                        return false;
                    }
                    if (!detail.channel) {
                        this.$message.error(`第 ${i + 1} 行：请选择备货渠道`);
                        return false;
                    }
                    if (!detail.unitName) {
                        this.$message.error(`第 ${i + 1} 行：单位不能为空`);
                        return false;
                    }
                    if (!detail.requiredQuantity || detail.requiredQuantity <= 0) {
                        this.$message.error(`第 ${i + 1} 行：申请备货数量必须大于0`);
                        return false;
                    }
                    if (detail.hasReport === null || detail.hasReport === undefined) {
                        this.$message.error(`第 ${i + 1} 行：请选择是否有报告`);
                        return false;
                    }
                    if (!this.validateDetailNumbers(detail)) {
                        this.$message.error(`第 ${i + 1} 行：成本、销量、库存、起订量和工期不能小于0`);
                        return false;
                    }
                    if ((Number(detail.estimatedGoldWeight) || 0) > 0 && !detail.goldMaterialCode) {
                        this.$message.error(`第 ${i + 1} 行：填写预计金重后必须选择金料材质`);
                        return false;
                    }
                    if (detail.allowSupplierGoldDebt && (!(Number(detail.provisionalGoldPrice) > 0) || !detail.suggestSupplierCode)) {
                        this.$message.error(`第 ${i + 1} 行：允许供应商欠料时必须选择供应商并填写预估金价`);
                        return false;
                    }
                    if (detail.orderDate && detail.estShipDate && new Date(detail.estShipDate) < new Date(detail.orderDate)) {
                        this.$message.error(`第 ${i + 1} 行：预计出货时间不能早于下单时间`);
                        return false;
                    }
                    if (detail.estShipDate && detail.estInboundDate && new Date(detail.estInboundDate) < new Date(detail.estShipDate)) {
                        this.$message.error(`第 ${i + 1} 行：预计入库时间不能早于预计出货时间`);
                        return false;
                    }
                    this.onQuantityOrPriceChange(detail)
                }

                // 提交数据
                this.$kaung.post({ url: '/' + this.$options.name + '/PostForms', data: { master: this.forms, details: this.details } }).then(res => {
                    if (res.code === 200) {
                        this.$message({ message: res.content, type: res.type });
                        this.back();
                    }
                }).catch(err => {
                    this.$message.error('提交失败：' + (err.message || '未知错误'));
                });
            });
        },
        back() { this.$router.back() },

        companyChange(departmentID) {
            this.forms.departmentID = departmentID || '';
            this.departments = [];
            var that = this;
            if (this.forms.companyID) {
                this.$kaung.departments(this.forms.companyID).then((res) => {
                    that.departments = res;
                    if (that.forms.departmentID) {
                        that.forms.departmentName = that.findTreeLabel(res, that.forms.departmentID) || that.forms.departmentName
                    }
                });
            }
        },

        onQuantityOrPriceChange(row) {
            const quantity = Number(row.requiredQuantity) || 0
            const price = Number(row.estimatedPrice) || 0
            row.estimatedAmount = Number((quantity * price).toFixed(4))
        },

        refreshSalesAndStock() {
            if (this.salesAndStockRefreshing) return
            if (!this.forms.companyID) {
                this.$message.warning('请先选择所属公司')
                return
            }

            const items = []
            let skippedCount = 0
            this.details.forEach((detail, index) => {
                if (!detail.detailCode || !detail.channel) {
                    skippedCount++
                    return
                }
                items.push({
                    rowKey: String(index),
                    detailCode: detail.detailCode,
                    channel: detail.channel
                })
            })

            if (!items.length) {
                this.$message.warning('没有可刷新的明细，请先选择SKU和备货渠道')
                return
            }

            this.salesAndStockRefreshing = true
            refreshRequisitionSalesAndStock(this.forms.companyID, items).then(res => {
                if (!res || res.code !== 200) {
                    this.$message.error(res?.content || '刷新近30天销量及部门库存失败')
                    return
                }

                const results = Array.isArray(res.data) ? res.data : []
                results.forEach(item => {
                    const index = Number(item.rowKey)
                    if (Number.isInteger(index) && this.details[index]) {
                        this.details[index].monthSalesQty = Number(item.monthSalesQty) || 0
                        this.details[index].deptStockQty = Number(item.deptStockQty) || 0
                        this.details[index].otherDeptStockQty = Number(item.otherDeptStockQty) || 0
                    }
                })

                const skippedText = skippedCount ? `，已跳过 ${skippedCount} 行未选SKU或渠道的明细` : ''
                this.$message.success(`已刷新 ${results.length} 行近30天销量及部门库存${skippedText}`)
            }).catch(err => {
                console.error('刷新采购申请近30天销量及部门库存失败:', err)
                this.$message.error('刷新近30天销量及部门库存失败，原有数据已保留')
            }).finally(() => {
                this.salesAndStockRefreshing = false
            })
        },

        isSkuFieldDisabled(row, field) {
            return this.isView || Boolean(row.id) || Boolean(row._skuLockedFields && row._skuLockedFields[field])
        },

        buildProductSpec(item) {
            const parts = []
            const detailUnit = (item.detailUnit || '').trim()
            if (detailUnit) parts.push(detailUnit)
            if (item.productSize !== null && item.productSize !== undefined && item.productSize !== '') {
                const size = `${Number(item.productSize)}${item.productSizeUnit || ''}`
                if (!parts.some(part => part.toLowerCase() === size.toLowerCase())) parts.push(size)
            }
            return parts.join(' / ')
        },

        onBrandChange(row, value) {
            const selected = this.brands.find(item => (item.brandCode || item.BrandCode) === value)
            row.brandName = selected ? (selected.brandName || selected.BrandName || '') : ''
        },

        onSupplierChange(row, value) {
            const selected = this.suppliers.find(item => item.supplierCode === value)
            row.suggestSupplierName = selected ? (selected.supplierName || selected.text || '') : ''
        },

        recalculateSchedule(row, recalculateShip = true) {
            if (recalculateShip) {
                if (row.orderDate && row.leadDays !== null && row.leadDays !== undefined && row.leadDays !== '') {
                    row.estShipDate = this.addDays(row.orderDate, Number(row.leadDays))
                } else {
                    row.estShipDate = null
                }
            }

            if (row.estShipDate && row.qcLeadDays !== null && row.qcLeadDays !== undefined && row.qcLeadDays !== '') {
                row.estInboundDate = this.addDays(row.estShipDate, Number(row.qcLeadDays))
            } else {
                row.estInboundDate = null
            }
        },

        addDays(value, days) {
            const date = new Date(value)
            date.setDate(date.getDate() + days)
            return date
        },

        formatAmount(value) {
            return (Number(value) || 0).toFixed(2)
        },

        findTreeLabel(nodes, value) {
            for (const node of nodes || []) {
                if (node.value === value || node.id === value) return node.label || node.name || node.text || ''
                const childLabel = this.findTreeLabel(node.children, value)
                if (childLabel) return childLabel
            }
            return ''
        },

        getDefaultChannel() {
            const userInfo = this.$store.getters.getUserInfo || {}
            return this.forms.departmentName
                || this.findTreeLabel(this.departments, this.forms.departmentID)
                || userInfo.departmentName
                || ''
        },

        onDepartmentChange(value) {
            this.forms.departmentID = value || ''
            this.forms.departmentName = this.findTreeLabel(this.departments, value)
            const defaultChannel = this.getDefaultChannel()
            this.details.forEach(detail => {
                if (!detail.channel) detail.channel = defaultChannel
            })
        },

        validateDetailNumbers(detail) {
            const values = [
                detail.estimatedPrice,
                detail.monthSalesQty,
                detail.deptStockQty,
                detail.otherDeptStockQty,
                detail.transferQty,
                detail.minOrderQty,
                detail.nonFinishedQty,
                detail.leadDays,
                detail.qcLeadDays
            ]
            return values.every(value => value === null || value === undefined || value === '' || Number(value) >= 0)
        },

        deleteDetailRow(index) {
            this.$confirm('确定要删除该明细行吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.details.splice(index, 1)
                this.$message({ type: 'success', message: '已删除' })
            }).catch(() => { })
        },

        downloadTemplate() {
            const billId = this.requisitionId || ''
            if (!billId) {
                this.$message.warning('请先保存申请单后再下载模板')
                return
            }

            this.$kaung.fetch({
                url: '/PurchaseRequisitionDetail/DownloadTemplate',
                method: 'get',
                params: { billId }
            }).then(res => {
                if (res && res.code === 200) {
                    this.$notify({
                        title: '导出成功',
                        message: res.content || '采购申请明细已导出',
                        type: 'success',
                        duration: 10000
                    })
                    if (res.data) {
                        window.location.href = process.env.VUE_APP_BASEURL + res.data
                    } else {
                        this.$message.warning('后端未返回下载地址')
                    }
                } else {
                    this.$message.error(res?.content || res?.message || '下载模板失败')
                }
            }).catch(err => {
                console.error('下载采购申请明细模板失败:', err)
                this.$message.error('下载模板失败，请稍后重试')
            })
        }
    }
}
</script>

<style scoped>
.attachments-pane {
    padding: 10px 0 0 10px;
}

.attachments-alert {
    margin-bottom: 12px;
}

.attachments-file-text {
    font-size: 12px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    text-align: center;
    overflow-wrap: anywhere;
}

.attachments-pane :deep(.el-upload-list--picture-card .el-upload-list__item),
.attachments-pane :deep(.el-upload--picture-card) {
    width: 100px;
    height: 100px;
}

.attachments-pane :deep(.el-upload-list--picture-card .el-upload-list__item-thumbnail) {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.attachments-pane :deep(.el-upload-list__item-actions span + span) {
    margin-left: 4px;
}

.sku-suggestion {
    display: flex;
    gap: 10px;
    justify-content: space-between;
}

.sku-suggestion span:last-child {
    color: #8492a6;
    font-size: 12px;
}

.required-column-label::before {
    color: var(--el-color-danger);
    content: '*';
    margin-right: 4px;
}

.month-sales-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    width: 100%;
}
</style>
